import { Injectable } from "@angular/core";
import { IParentDataForKYC } from "../../models/interfaces/kyc.interfaces";
import { STORAGE_KYC_DATA } from "../../models/constants/kyc.constants";

@Injectable()
export class KycNotStartedUtils {
  public getParentDataFromStorage(): IParentDataForKYC {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KYC_DATA));
    } catch {
      return null;
    }
  }
}
